import { IMenuBar, IMenuList } from 'app/interfaces/menu-bar/menuBar.interface';
import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import './MenuBarComponent.scss';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';

const MenuBarComponent = function init(props: IMenuBar):React.ReactElement {
    const { menuList, loading } = props;

    function renderNavLink(menu: IMenuList): ReactElement {
        return (
            <div className="menu" key={menu.title}>
                <NavLink
                    to={menu.path}
                    className={(c) => `nav-link ${c.isActive ? "selected" : ""}`}
                >
                    {menu.title}
                </NavLink>
            </div>
        );
    }
    return (
        <div className="menu-container">
            {loading
                ? (
                <ShimmeringLoading
                    className="menu-container"
                    borderRadius={14}
                    width={530}
                />
            ) : (
                menuList.map((menu) => renderNavLink(menu))
            )}
        </div>
        );
};

export default MenuBarComponent;
